import React from "react";

export const useIsMainBlockScrolledDown = (
  mainContentRef: React.RefObject<HTMLDivElement>,
) => {
  const [isScrolledDown, setisScrolledDown] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const position = mainContentRef.current?.getBoundingClientRect().top || 0;
      setisScrolledDown(position < 0);
    };
    window.document.body.addEventListener("scroll", handleScroll);

    return () => {
      window.document.body.removeEventListener("scroll", handleScroll);
    };
  }, [mainContentRef]);

  return isScrolledDown;
};
